import { Outlet, useNavigate, useMatchRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { Sidebar } from '@/components/Sidebar';
import { CommandPalette } from '@/components/CommandPalette';
import { useAuth } from '@/hooks/useAuth';
import { useKeyboardShortcuts } from '@/hooks/useKeyboardShortcuts';

export function AppLayout() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const matchRoute = useMatchRoute();
  useKeyboardShortcuts();

  const isOnboarding = !!matchRoute({ to: '/onboarding' });

  useEffect(() => {
    if (!loading && !user) {
      navigate({ to: '/login' });
    }
    // Redirect to onboarding if no partner linked (except if already there)
    if (!loading && user && !user.partnerId && !isOnboarding) {
      navigate({ to: '/onboarding' });
    }
  }, [loading, user, navigate, isOnboarding]);

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!user) return null;

  // Onboarding is full-screen, no sidebar
  if (isOnboarding) {
    return <Outlet />;
  }

  return (
    <div className="flex h-screen">
      <Sidebar />
      <main className="flex-1 overflow-y-auto bg-muted p-6">
        <Outlet />
      </main>
      <CommandPalette />
    </div>
  );
}
